<template>
    <div class="qksm qksm9">
        <div class="nogap">
            <p><b>（四）国有资产占有使用情况</b></p>
            <p>
                截至2020年12月31日，{{$store.state.divData.divname}}所属各预算单位
                <span v-for="(value, key, index) in car">
                    {{key}}<reason type="integer" classname="qksm integer must" :name="key" v-model:value="car[key]"></reason>辆{{index==Object.keys(car).length-1?'。': (key=="共有车辆" ? "，其中，" :"、")}}
                </span>
                <span v-if="num(car.其他用车)>0">
                     其中，其他用车主要是
                    <reason type="textarea" classname="qksm widest" name="其他用车主要是" v-model:value="qksm['其他用车主要是']"></reason>
                </span>
            </p>
            <p>
                单位价值50万元以上通用设备<reason type="integer" classname="qksm integer must" name="通用设备" v-model:value="qksm['通用设备']"></reason>台（件、套），
                单位价值100万元以上专用设备<reason type="integer" classname="qksm integer must" name="专用设备" v-model:value="qksm['专用设备']"></reason>台（件、套）。
            </p>
            <p>
                <span v-if="isPdf">
                    <span v-if="num(qksm['安排通用设备'])==0 && num(qksm['安排专用设备'])==0">
                        2021年{{$parent.typeText}}预算未安排购置单位价值50万元以上通用设备或者单位价值100万元以上专用设备。
                    </span>
                    <span v-else-if="num(qksm['安排通用设备'])>0 && num(qksm['安排专用设备'])==0">
                        2021年{{$parent.typeText}}预算安排购置单位价值50万元以上通用设备{{isMoney(qksm['安排通用设备'])}}台（件、套），未安排购置单位价值100万元以上专用设备。
                    </span>
                    <span v-else-if="num(qksm['安排通用设备'])==0 && num(qksm['安排专用设备'])>0">
                        2021年{{$parent.typeText}}预算安排购置单位价值100万元以上专用设备{{isMoney(qksm['安排专用设备'])}}台（件、套），未安排购置单位价值50万元以上通设备。
                    </span>
                    <span v-else>2021年{{$parent.typeText}}预算安排购置单位价值50万元以上通用设备{{isMoney(qksm['安排通用设备'])}}台（件、套），单位价值100万元以上专用设备{{isMoney(qksm['安排专用设备'])}}台（件、套）。</span>
                </span>
                <span v-else>
                    2021年{{$parent.typeText}}预算安排购置单位价值50万元以上通用设备<reason type="integer" classname="qksm integer must" name="安排通用设备" v-model:value="qksm['安排通用设备']"></reason>台（件、套），单位价值100万元以上专用设备<reason type="integer" classname="qksm integer must" name="安排专用设备" v-model:value="qksm['安排专用设备']"></reason>台（件、套）。
                </span>
            </p>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm9",
        components: {
            reason,
        },
        data() {
            var qksm = this.$store.state.divData.qksm
            var arr = ["共有车辆", "实物保障用车", "机要通信用车", "应急保障用车","行政执法用车", "执法执勤用车", "特种专业技术用车", "离退休干部用车", "事业单位业务用车","其他用车"]
            var car = {};
            for (var i = 0; i < arr.length; i++) {
                car[arr[i]] = qksm[arr[i]]
            }
            return {
                isPdf: this.$parent.isPdf,
                qksm: qksm,
                car: car,
            }
        },
        created() {
            this.inspect()
        },
        updated: function () {
            this.inspect()
        },
        methods: {
            inspect() {
                var arr = Object.values(this.car)
                var sum = 0;
                for (var i = 1; i < arr.length; i++) {
                    sum = sum + this.num(arr[i])
                }
                if (this.num(arr[0]).toFixed(2) != this.num(sum).toFixed(2)) {
                    this.addOrSet("qksm24", "请检查本页《二、重要事项说明》中（四）国有资产占有使用情况，各项车辆使用情况总和应该等于单位拥有车辆总数。");
                } else {
                    this.remove("qksm24")
                }
            }
        }

    };
</script>